export default __webpack_public_path__ + "a8b04ace778065bde4fe692289c4775c.svg";